export const colors = {
  border: '#e6eaf0',
  inset: '#f8fafc',
  warn: '#fb8c00',
  ok: '#2e7d32',
  danger: '#c62828',
  textMuted: '#64748b',
  blueSoft: '#f6f8fb',
  green: '#22c55e',
};

export const statsBar = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  gap: 'clamp(24px, 6vw, 120px)',
  padding: '18px 20px',
  background: '#eef5ff',
  borderRadius: 12,
  border: '1px solid transparent',
  marginBottom: 12,
};

export const statPill = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 140,
  textAlign: 'center',
  lineHeight: 1.1,
};

export const statValue = {
  fontSize: 'clamp(20px, 2.4vw, 28px)', 
  fontWeight: 800,
  letterSpacing: 0.2,
  marginBottom: 4,
};

export const statLabel = {
  fontSize: 'clamp(11px, 1.1vw, 14px)',
  color: '#64748b',
};


export const timeChipDanger = {
  color: '#dc2626',
  background: '#fce5e5ff',
  borderColor: '#f8d0d0ff',
};

export const statusPillDanger = {
  color: '#dc2626',
  background: '#fce5e5ff',
  borderColor: '#f8d0d0ff',
};

export const rowHover = { cursor: 'pointer' };
export const rowPending = { background: '#fffdf7' };

export const chip = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  borderRadius: 999,
  padding: '2px 8px',
  fontSize: 12,
  border: '1px solid transparent',
};
export const chipWarn   = { background: '#fff8e1', color: colors.warn,   borderColor: '#ffe0b2' };
export const chipOk     = { background: '#e8f5e9', color: colors.ok,     borderColor: '#c8e6c9' };
export const chipDanger = { background: '#fdecef', color: colors.danger, borderColor: '#ffcdd2' };
export const formWrap = { background: '#fff', border: `1px solid ${colors.border}`, borderRadius: 12, padding: 12 };
export const detailsBox    = { background: colors.inset, borderTop: `1px solid ${colors.border}`, padding: 12 };
export const detailsHeader = { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 };
export const field         = { fontSize: 13, marginBottom: 6 };
export const fieldLabel    = { color: colors.textMuted, marginRight: 6, fontWeight: 600 };
export const collapseCellTd = { padding: 0, border: 'none' };
export const timeChipOk = { background: '#f3fcf6', color: colors.ok, borderColor: '#c8e6c9' };
export const timeChipWarn = { background: '#fff7ed', color: '#fb8c00', borderColor: '#fed7aa' };
export const statusPillOk = { background: colors.okSoft, color: colors.ok };
export const statusPillWarn = { background: colors.warnSoft, color: '#b45309' };

export const actionsRow = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8                                                                                                   ,
};

export const actionIconCircle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  borderRadius: '50%',
  background: '#e7f7ee',
  color: colors.ok,
  border: `1px solid #c8e6c9`,
};
export const actionIconCircleDisabled = {
  opacity: 0.5,
};

export const actionPill = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '6px 12px',
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1,
  gap: 6,
  border: '1px solid transparent',
  background: '#fff',
  cursor: 'pointer',
};

export const actionPillOk = {
  background: '#e8f5e9',
  color: '#2e7d32',
  borderColor: '#c8e6c9',
};

export const actionPillDanger = {
  background: '#fee2e2', 
  color: '#b91c1c',      
  borderColor: '#fecaca',
};

export const actionPillDisabled = {
  opacity: 0.6,
  cursor: 'not-allowed',
};

export const actionPillDisabledOutline = {
  opacity: 0.6,
  cursor: 'not-allowed',
};

export const cancelGlyph = {
  fontWeight: 700,
  marginRight: 6,
};

export const tableWrap = {
  background: '#fff',
  border: `1px solid ${colors.border}`,
  borderRadius: 12,
  overflowX: 'auto',
  overflowY: 'hidden',
  WebkitOverflowScrolling: 'touch',
};

export const table = {
  width: '100%',
  minWidth: 1100,
  borderCollapse: 'separate',
  borderSpacing: 0,
};

export const thead = {
  background: '#f3f6fb',
  fontSize: 12,
  whiteSpace: 'nowrap',
};

export const colDesc = {
  maxWidth: 320,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const statusCellRow = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 10,
  flexWrap: 'nowrap',
  whiteSpace: 'nowrap',
};

export const timeChip = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  borderRadius: 999,
  fontSize: 12,
  border: `1px solid ${colors.border}`,
  lineHeight: 1,
  flexShrink: 0, 
  whiteSpace: 'nowrap',
};

export const statusPill = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '6px 12px',
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1,
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

export const tbodyAlignMiddle = {
  verticalAlign: 'middle',
};